<template>
  <div v-if="loadingShow">
    <div class="container">
      <div class="card">
        <!-- <div class="title" style="margin-left:10px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-putcontract"></use>
          </svg>
          <span>
              {{ customer.custName }}
              <van-tag round type="primary" v-if="customer.contractStatus == 1">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="success" v-if="customer.contractStatus == 2">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="danger" v-if="customer.contractStatus == 3">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
              <van-tag round type="warning" v-if="customer.contractStatus == 4">{{contractStatusFormat2(customer.contractStatus)}}</van-tag>
          </span>
          <van-icon v-if="!activeName" name="edit" color="#f8df0d" size="20px" class="icon-edit" v-hasPermi="['cont:newContract:edit']" @click="edit"/>
          <van-icon v-if="!activeName" name="delete" color="red" size="20px" class="icon-delete" v-hasPermi="['cont:newContract:remove']" @click="remove" />
        </div> -->
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span style="flex: 1">{{customer.contractName}}</span>
          <van-tag round :type="customer.contractStatus==4?'danger':'success'">{{ formatHandel('contractStatus',customer.contractStatus) }}</van-tag>
        </div>
        <div class="title_des">【{{customer.businessTypeName}}】</div>
        <!-- <div class="approval-status" v-if="(activeName == 1 || activeName == 2) && customer.contractStatus != 9 && customer.contractStatus != 30">
          <span class="detail_span">审批状态：待{{customer.spLabelStatus}}审批</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div>
        <div class="approval-status" v-if="activeName && activeName != 1 && activeName != 2 && customer.spNo">
          <span>审批详情：{{customer.spLabelStatus}}</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div>
        <div class="approval-status" v-if="!activeName && customer.contractStatus == 4">
          <span>审批状态：驳回</span>
          <van-button size="mini" type="info" @click="viewStatus">详情</van-button>
        </div> -->
        <van-tabs v-model="active">
          <van-tab title="基本信息">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ customer.contractNum }}</span>
              </div>

              <!-- <div class="item" >
                <span class="key">我方签约部门：</span>
                <span class="value">{{ customer.deptName }}</span>
              </div>
              <div class="item" >
                <span class="key">我方签约人：</span>
                <span class="value">{{ customer.userName }}</span>
              </div>  -->
              <div class="item" style="width: 48%">
                <span class="key">合同模板：</span>
                <span class="value">{{formatHandel('templateType',customer.templateType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">框架类型：</span>
                <span class="value">{{formatHandel('frameType',customer.frameType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">垫款方式：</span>
                <span class="value">{{formatHandel('payType',customer.payType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">合同金额：</span>
                <span class="value">{{ customer.contractMoney }}(元)</span>
              </div>
              <div class="item">
                <span class="key">开票方式：</span>
                <span class="value">{{formatHandel('invoicingMethod',customer.invoicingMethod)}}</span>
              </div>
              <div class="item">
                <span class="key">发票类型：</span>
                <span class="value">{{formatHandel('invoiceType',customer.invoiceType)}}</span>
              </div>
              <div class="item" >
                <span class="key">执行时间：</span>
                <span class="value">{{ customer.startTime }}至{{customer.endTime}}</span>
              </div>

              <div v-if="isVendite" class="gd_box">
                <!-- <div class="item" style="width: 48%">
                  <span class="key">付款周期：</span>
                  <span class="value">{{customer.payCycle}}(天)</span>
                </div> -->
                <div class="item" style="width: 48%">
                  <span class="key">媒介归属：</span>
                  <span class="value">{{formatHandel('mediaType',customer.mediaType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">合作政策：</span>
                  <span class="value">{{formatHandel('cooperationPolicy',customer.cooperationPolicy)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">运营方式：</span>
                  <span class="value">{{formatHandel('operationMode',customer.operationMode)}}</span>
                </div>
                <div class="item" v-if="customer.payType == '2'">
                  <span class="key">用印日期：</span>
                  <span class="value">{{ customer.useSealTime }}</span>
                </div>
              </div>
              <div v-if="isVendite && customer.payType == '2'" class="gd_box">
                <div class="item" >
                  <span class="key">授信账期类型：</span>
                  <span class="value">{{formatHandel('creditCycleType',customer.creditCycleType)}}</span>
                </div>
                <div class="item" >
                  <span class="key">授信账期时间：</span>
                  <span class="value">{{ customer.creditCycleValue }}(天)</span>
                </div>
                <!-- <div class="item">
                  <span class="key">回款账期：</span>
                  <span class="value">{{customer.collectionPeriod}}(天)</span>
                </div> -->
                <!-- <div class="item" style="width: 48%">
                  <span class="key">授信金额：</span>
                  <span class="value">{{ customer.creditMoney}}(元)</span>
                </div> -->
                <div class="item" >
                  <span class="key">垫款事由：</span>
                  <span class="value">{{ customer.advancesCycle }}</span>
                </div>
              </div>
              <div class="item" >
                <span class="key">条款说明：</span>
                <span class="value">{{ customer.content }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="签约信息">
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">信息提供部门：</span>
                <span class="value">{{ customer.infoDeptName}}</span>
              </div>
              <div class="item">
                <span class="key">信息提供人：</span>
                <span class="value">{{ customer.infoUserName}}</span>
              </div>
              <div class="item">
                <span class="key">对方签约人：</span>
                <span class="value">{{ customer.signedUser }}</span>
              </div>
              <div class="item">
                <span class="key">对方签约人电话：</span>
                <span class="value">{{ customer.signedUserMobile }}</span>
              </div>
              <div class="item">
                <span class="key">对方签约人邮箱：</span>
                <span class="value">{{ customer.signedUserEmail }}</span>
              </div>
              <div class="item">
                <span class="key">对方签约人微信：</span>
                <span class="value">{{ customer.signedUserWx }}</span>
              </div>
              <div class="item" >
                <div class="item" >
                <span class="key">我方签约主体地位：</span>
                <span class="value">{{formatHandel('signedMainType',customer.signedMainType)}}</span>
              </div>
                <span class="key">我方签约主体机构：</span>
                <span class="value">{{customer.companyName}}</span>
              </div>
              <div class="item" >
                <span class="key">我方签约部门：</span>
                <span class="value">{{ customer.deptName }}</span>
              </div>
              <div class="item" >
                <span class="key">我方签约人：</span>
                <span class="value">{{ customer.userName }}</span>
              </div>
              <div class="item" v-if="customer.templateType == 2">
                <span class="key">申请用印日期：</span>
                <span class="value">{{ customer.useSealTime }}</span>
              </div>
              <div class="item" v-if="customer.templateType == 2 && customer.payType != 2">
                <span class="key">用印事由：</span>
                <span class="value">{{ customer.advancesCycle }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">交付日期：</span>
                <span class="value">{{ customer.deliveryTime }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">签约时间：</span>
                <span class="value">{{ customer.signTime }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="附件信息">
            <div class="item">
              <van-list :finished="finished" finished-text="没有更多了"  @load="getContractFileList" v-if="contractFileList.length > 0">
                <van-cell v-for="(item,index) in contractFileList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <!-- <div>
                        <span class="key"> 附件标题：</span>
                        <span class="value">{{ item.title }}</span>
                      </div> -->
                      <div>
                        <span class="key"> 附件类型：</span>
                        <span class="value">{{formatHandel('fileType',item.fileType)}}</span>
                      </div>
                      <div v-if="item.amount">
                        <span class="key"> 合同金额：</span>
                        <span class="value">{{ item.amount }}(元)</span>
                      </div>
                      <div v-if="item.fileDesc">
                        <span class="key"> 附件描述：</span>
                        <span class="value">{{ item.fileDesc }}</span>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction:column;justify-content: space-around">
                      <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">附件详情</a>
                      <!-- <span v-else @click="showImage(item.url)">附件详情</span> -->
                      <!-- <span v-if="activeName == 0" style="color: #ff976a" @click="modifyFile(item)">修改</span>
                      <span v-if="activeName == 0" style="color: #ee0a24" @click="deleteFile(item)">删除</span> -->
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contractFileList.length == 0" />
              <!-- <div v-if="contractFileList.length == 0" style="background-color: #fff;text-align:center;color:red;height:50px;line-height:50px;">暂无附件记录！</div> -->
            </div>
          </van-tab>
          <van-tab title="收款约定">
            <div class="item">
              <van-list :finished="finished" finished-text="没有更多了"  @load="getContPayAgreeList" v-if="contPayAgreeList.length > 0">
                <van-cell v-for="(item,index) in contPayAgreeList" :key="index">
                  <div class="flex-between" v-if="item">
                    <div style="max-width: 100%">
                      <div>
                        <span class="key"> 款项内容：</span>
                        <span class="value">{{formatHandel('contPayType',item.contPayType)}}</span>
                      </div>
                      <div>
                        <span class="key"> 付款日期：</span>
                        <span class="value">{{item.payTime}}</span>
                      </div>
                      <div>
                        <span class="key"> 付款单位：</span>
                        <span class="value">{{ item.custName }}</span>
                      </div>
                      <div>
                        <span class="key"> 收款合同方：</span>
                        <span class="value">{{ item.companyName }}</span>
                      </div>
                      <div v-if="item.entrustCustName">
                        <span class="key"> 委托付款单位：</span>
                        <span class="value">{{ item.entrustCustName }}</span>
                      </div>
                      <div>
                        <span class="key"> 付款条件：</span>
                        <span class="value">{{ item.payCondition }}</span>
                      </div>
                      <div v-if="item.contractMoney">
                        <span class="key"> 付款金额：</span>
                        <span class="value">{{ item.contractMoney }}(元)</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contPayAgreeList.length == 0" />
              <!-- <div v-if="contPayAgreeList.length == 0" style="background-color: #fff;text-align:center;color:red;height:50px;line-height:50px;">暂无收款约定！</div> -->
            </div>
          </van-tab>
          <van-tab title="合同日志">
            <div class="item">
              <!-- <van-list :finished="finished" finished-text="没有更多了"  @load="getContractLogList" v-if="contractLogList.length > 0">
                <van-cell-group v-for="(item,index) in contractLogList" :key="index">
                  <van-cell :title="item.remark" value="" :label="item.createTime" />
                </van-cell-group>
              </van-list>
              <empty v-if="contractLogList.length == 0" /> -->
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in contractLogList" :key="index">
                  <span>{{item.remark}}</span>
                  <div style="margin-top: 5px">{{item.createTime}}</div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <van-grid class="grid-wrap" :column-num="2" v-if="customer.contractStatus == 5">
        <van-grid-item>
          <div class="flex-center" @click="handleYyConfirm(customer)">
            <van-icon name="sign" size="22" color="#07c160" />
            <span>用印确认</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" @click="handleReject(customer)">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>驳回</span>
          </div>
        </van-grid-item>
        <!-- <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newContract:spApply']" v-if="customer.payType==1 && customer.templateType==2">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span @click="handleSpApply(customer)">用章申请</span>
          </div>
          <div class="flex-center" v-hasPermi="['cont:newContract:yyApply']" v-if="customer.payType==1 && customer.templateType==1">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span @click="handleYyApply(customer)">用印申请</span>
          </div>
          <div class="flex-center" v-hasPermi="['cont:newContract:dkApply']" v-if="customer.payType==2">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span @click="handleDkApply(customer)">垫款申请</span>
          </div>
        </van-grid-item> -->
      </van-grid>
      <!-- <van-grid class="grid-wrap" v-if="activeName=='3' || activeName=='4'" :column-num="2">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newContract:yzVerify']" v-if="activeName=='3' && customer.contractStatus != '30'">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span @click="handleConfirm(customer)">用章确认</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newContract:zfVerify']" v-if="(activeName=='3' || activeName=='4') && customer.contractStatus != '30'">
            <van-icon name="failure" size="22" color="#ff976a" />
            <span @click="handleNullify(customer)">作废</span>
          </div>
        </van-grid-item>
      </van-grid> -->
      <!-- <van-grid class="grid-wrap" v-if="activeName=='0' && active == '2'" :column-num="2">
        <van-grid-item>
          <div class="flex-center">
            <van-icon name="add-o" size="22" color="#1989fa" />
            <span @click="addFile(customer)">新增附件</span>
          </div>
        </van-grid-item>
        <van-grid-item />
      </van-grid> -->
      <!-- <div class="link" v-if="activeName">
        <van-button v-if="activeName=='2' && customer.contractStatus != '30'" class="linkaddBtn" round block type="info" size="small"
          @click="handleConfirm(customer)" v-hasPermi="['cont:newContract:edit']">用章确认</van-button>
        <van-button v-if="activeName=='3'" class="linkaddBtn" round block type="info" size="small"
          @click="handleSign(customer)" v-hasPermi="['cont:newContract:placeFile']">签署归档</van-button>
        <van-button v-if="(activeName=='2' || activeName=='3') && customer.contractStatus != '30'" class="linkaddBtn" round block type="warning" size="small"
          @click="handleNullify(customer)" v-hasPermi="['cont:newContract:edit']">作废</van-button>
      </div>
      <div class="link" v-else>
        <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==1 && customer.templateType==2"
          @click="handleSpApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">用章申请</van-button>
        <van-button class="linkaddBtn" size="small" round block type="info" v-if="customer.contractStatus==0 && customer.payType==2"
          @click="handleDkApply(customer)" v-preventReClick v-hasPermi="['cont:newContract:spApply']">垫款申请</van-button>
      </div> -->
    </div>
    <!-- <van-dialog v-model="nullifyFormShow" title="合同作废" width="95%" style="height:50%" class="nullifyClue" :beforeClose="nullifyBeforeClose" show-cancel-button>
      <van-form ref="nullifyForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="nullifyForm.nullifyReason"
            autosize required
            label="作废原因"
            placeholder="请输入作废原因"
            type="textarea"
            show-word-limit
            :rules="[{ required: true }]"/>
        </van-cell-group>
      </van-form>
    </van-dialog> -->
    <!-- <van-dialog v-model="fileFormShow" :title="isChange?'附件变动':'签署归档'" width="95%" style="height:80%" class="fileClue" :beforeClose="fileBeforeClose" show-cancel-button>
      <van-form ref="fileForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-field v-model="fileForm.title" label="附件标题" placeholder="请输入附件标题" :rules="[{ required: true }]" required/>
          <van-field v-model="fileForm.amount" label="变动金额(元)" placeholder="请输入变动金额" type="digit" maxlength="8" />
          <van-field v-if="isChange" v-model="fileForm.fileTypeName" label="附件类型" placeholder="请选择附件类型" readonly clickable  @click="showPicker('fileType')" :rules="[{ required: true }]" required />
          <van-field v-else v-model="fileForm.fileTypeName" label="附件类型" disabled required/>
          <van-field
            v-model="fileForm.fileDesc"
            rows="2"
            autosize
            label="附件描述"
            placeholder="请输入附件描述"
            type="textarea"
            show-word-limit
          />
          <van-field v-model="fileForm.url" label="其他附件" placeholder="需要上传的PDF文件" readonly :rules="[{ required: true }]" required >
            <template #button>
              <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/pdf,.doc,.docx,">
                <van-button icon="plus" type="info" size="mini">上传附件</van-button>
              </van-uploader>
            </template>
          </van-field>
          <div style="padding: 10px 20px 0 0;text-align: right;font-size: 14px" >
            <a v-if="fileForm.url" :href="fileForm.url" @click="downloadUrlFile(fileForm.url,fileForm.title + '附件')">{{fileForm.fileName}}    查看附件</a>
          </div>
      </van-form>
    </van-dialog> -->
    <!-- <van-dialog v-model="statusShow" title="审批详情" width="95%" style="height:60%;overflow-y:auto" class="auditDetails" :show-confirm-button="false" :closeOnClickOverlay="true">
      <van-cell-group inset>
        <van-cell v-for="(item,index) in viewStatusList" :key="index" :title="item.userName">
          <template>
            <van-tag v-if="activeName" :type="item.spStatus == 2?'success':'warning'">{{item.spStatus == 2?'已通过':'审批中'}}</van-tag>
            <van-tag v-else :type="item.spStatus == 3?'danger':'warning'">{{item.spStatus == 3?'驳回':'审批中'}}</van-tag>
          </template>
          <template #label>
            <div v-if="item.spTime">审批时间：{{item.spTime}}</div>
            <div v-if="item.spComment">审批备注：{{item.spComment}}</div>
          </template>
        </van-cell>
      </van-cell-group>
      <empty v-if="viewStatusList.length == 0" />
    </van-dialog> -->

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>

    <van-image-preview v-model="imagePreviewShow" :images="imagesArr" />
      <!-- <template v-slot:index>第{{ index }}页</template> -->
    <!-- </van-image-preview> -->
  </div>
</template>

<script>

import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import { Dialog, Toast, ImagePreview } from 'vant'
import Empty from '@/components/common/Empty'

export default {
  components: {
    Empty,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      loadingShow: false,
      active: 0,
      activeName: '',
      contractId: '',
      finished: true,
      isVendite: false, // 是否是 销售/数字技术类
      options: {
        mediaTypeOptions: [],
        cooperationPolicyOptions: [],
        operationModeOptions: [],
        invoicingMethodOptions: [],
        invoiceTypeOptions: [],
        signedMainTypeOptions: [],
        templateTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: [],
        payTypeOptions: [],
        contPayTypeOptions: [],
        fileTypeOptions: [],
        creditCycleTypeOptions: [],
        contractStatusOptions: []
      },
      // 合同附件
      contractFileList: [],
      // 收款约定
      contPayAgreeList: [],
      // 合同日志
      contractLogList: [],
      pdfSrc: '', // pdf文件地址
      numPages: 0,
      customer: {},
      queryContFileParams: {
        contactId: null
      },
      nullifyFormShow: false,
      nullifyForm: {
        nullifyReason: '',
        contractStatus: 30,
        contactId: ''
      },
      fileFormShow: false,
      fileForm: {
        contractId: '',
        title: '',
        fileType: '4',
        fileTypeName: '签署归档',
        url: '',
        amount: '',
        fileDesc: '',
        contractStatus: 7
      },
      statusShow: false,
      viewStatusList: [],
      isChange: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      imagePreviewShow: false,
      imagesArr: []
    }
  },
  async created() {
    await this.getOptions()
    const { contractId, active } = this.$route.query
    this.activeName = active
    this.queryContFileParams.contractId = contractId

    await this.getContractDetail()
    await this.getContractFileList()
    await this.getContPayAgreeList()
    await this.getContractLogList()
  },
  mounted() {
    // this.getCustLevelList();
    this.init()
    // this.queryListVisit();
  },
  methods: {
    // showImage(url) {
    //   this.imagesArr = url.split(',')
    //   this.imagePreviewShow = true
    // },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getOptions() {
      // 媒介归属
      getDicts('media_type').then(res => {
        this.options.mediaTypeOptions = res.data
      })
      // 合作政策
      getDicts('cooperation_policy').then(res => {
        this.options.cooperationPolicyOptions = res.data
      })
      // 运营方式
      getDicts('operation_mode').then(res => {
        this.options.operationModeOptions = res.data
      })
      // 开票方式
      getDicts('Invoicing_method').then(res => {
        this.options.invoicingMethodOptions = res.data
      })
      // 发票类型
      getDicts('Invoice_type').then(res => {
        this.options.invoiceTypeOptions = res.data
      })
      // 我方主体地址
      getDicts('signed_main_type').then(res => {
        this.options.signedMainTypeOptions = res.data
      })
      // 合同模板
      getDicts('template_type').then(res => {
        this.options.templateTypeOptions = res.data
      })
      // 框架类型
      getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      // 付款类型
      getDicts('cont_pay_type').then(res => {
        this.options.contPayTypeOptions = res.data
      })
      // 附件类型
      getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      // 授信账期类型
      getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
      // 合同状态
      getDicts('contract_status').then(res => {
        this.options.contractStatusOptions = res.data
      })
    },
    async init() {
      // 修改主体框架标题
      document.title = 'CONT-合同详情'
    },
    async getContractDetail() {
      const res = await newContract.getContract(this.queryContFileParams.contractId)
      if (res.code === 200) {
        this.loadingShow = true
        this.customer = res.data
        const name = res.data.businessTypeName.split('/')
        if (name[0] == '销售' && name[1] == '数字技术类') {
          this.isVendite = false
        } else {
          this.isVendite = true
        }
      }
    },
    // 获取合同附件列表
    async getContractFileList() {
      newContract.listContractFile(this.queryContFileParams).then(response => {
        this.contractFileList = response.rows
      })
    },
    // 获取收款约定列表
    async getContPayAgreeList() {
      newContract.listPayAgree(this.queryContFileParams).then(response => {
        this.contPayAgreeList = response.rows
      })
    },
    // 获取合同操作记录
    async getContractLogList() {
      const params = {
        contractId: this.queryContFileParams.contractId,
        bigType: 1
      }
      newContract.listContractLog(params).then(response => {
        this.contractLogList = response.rows
      })
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    // edit() {
    //   this.$router.push('/cont/contract/add?contractId=' + this.customer.contractId)
    // },
    // async remove() {
    //   Dialog.confirm({
    //     message: '是否确认删除此条数据'
    //   })
    //     .then(() => {
    //       this.delete()
    //     })
    //     .catch(() => {
    //     // on cancel
    //     })
    // },
    // async delete() {
    //   const res = await newContract.deleteContract(this.customer.contractId)
    //   if (res.code === 200) {
    //     await Toast.success('成功删除!')
    //     setTimeout(() => {
    //       this.$router.go(-1)
    //     }, 500)
    //   }
    // },
    // // uploadPDF
    // async uploadPDF(id) {
    //   const res = await newContract.fjPostContractid({ contractId: id })
    //   if (!res.code === 200) {
    //     await Toast.fail(res.message)
    //   }
    // },
    // 用章申请
    async handleYyConfirm(row) {
      // console.log(row)
      // console.log(this.contractFileList)

      // if (this.contractFileList.length == 0) {
      //   Toast.fail('请在修改中添加合同附件信息!')
      //   return
      // }
      Dialog.confirm({
        message: '是否用印确认'
      })
        // .then(() => {
        //   this.uploadPDF(row.contractId)
        // })
        .then(() => {
          this.yyConfirm(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async yyConfirm(val) {
      const res = await newContract.updateContract({ contractId: val, contractStatus: 6 })
      if (res.code === 200) {
        await Toast.success('用印确认成功!')
        setTimeout(() => {
          this.getContractDetail()
        }, 500)
      }
    },
    // 垫款申请
    handleReject(row) {
      // if (this.contractFileList.length == 0) {
      //   Toast.fail('请在修改中添加合同附件信息!')
      //   return
      // }
      Dialog.confirm({
        message: '是否确认驳回'
      })
        // .then(() => {
        //   this.uploadPDF(row.contractId)
        // })
        .then(() => {
          this.reject(row.contractId)
        })
        .catch(() => {
        // on cancel
        })
    },
    async reject(val) {
      const res = await newContract.updateContract({ contractId: val, contractStatus: 4 })
      if (res.code === 200) {
        await Toast.success('驳回成功!')
        setTimeout(() => {
          this.getContractDetail()
        }, 500)
      }
    },
    // // 作废
    // handleNullify(row) {
    //   this.contractId = row.contractId
    //   this.nullifyFormShow = true
    // },
    // async nullifyBeforeClose(type, done) {
    //   if (type === 'confirm') {
    //     try {
    //       await this.$refs.nullifyForm.validate()
    //       this.nullifyForm.contractId = this.contractId
    //       await newContract.updateContract(this.nullifyForm)
    //       await this.reset()
    //         .then(() => {
    //           Toast.success('作废成功')
    //           this.nullifyFormShow = false
    //           setTimeout(() => {
    //             this.$router.go(-1)
    //           }, 500)
    //         }).catch(() => {})
    //       done()
    //     } catch (err) {
    //       return done(false)
    //     }
    //     return done(false)
    //   } else {
    //     done()
    //     this.nullifyFormShow = false
    //   }
    // },
    // // 清空表单
    // async reset() {
    //   this.nullifyForm = {
    //     nullifyReason: '',
    //     contractStatus: 30,
    //     contactId: ''
    //   }
    //   this.fileForm = {
    //     contractId: '',
    //     title: '',
    //     fileType: '4',
    //     fileTypeName: '签署归档',
    //     url: '',
    //     amount: '',
    //     fileDesc: '',
    //     contractStatus: 7
    //   }
    // },
    // // 用章确认
    // handleConfirm(row) {
    //   Dialog.confirm({
    //     message: '是否用章确认此条数据'
    //   })
    //     .then(() => {
    //       this.confirm(row.contractId)
    //     })
    //     .catch(() => {
    //     // on cancel
    //     })
    // },
    // async confirm(val) {
    //   const res = await newContract.updateContract({ contractId: val, contractStatus: 6 })
    //   if (res.code == 200) {
    //     await Toast.success('用章确认成功!')
    //     setTimeout(() => {
    //       this.$router.go(-1)
    //     }, 500)
    //   }
    // },
    // // 用印申请
    // handleYyApply(row) {
    //   if (this.contractFileList.length == 0) {
    //     Toast.fail('请在修改中添加合同附件信息!')
    //     return
    //   }
    //   Dialog.confirm({
    //     message: '是否进行用印申请'
    //   })
    //     .then(() => {
    //       this.uploadPDF(row.contractId)
    //     })
    //     .then(() => {
    //       this.yyApply(row.contractId)
    //     })
    //     .catch(() => {
    //     // on cancel
    //     })
    // },
    // async yyApply(val) {
    //   const res = await newContract.yyApply({ contractId: val })
    //   if (res.code == 200) {
    //     await Toast.success('用印申请成功!')
    //     setTimeout(() => {
    //       this.$router.go(-1)
    //     }, 500)
    //   }
    // },
    // // 签署归档
    // handleSign(row) {
    //   this.contractId = row.contractId
    //   this.fileFormShow = true
    // },
    // // 修改合同附件
    // modifyFile(row) {
    //   console.log(row)
    //   this.isChange = true
    //   this.fileForm = row
    //   this.fileForm.fileTypeName = this.formatHandel('fileType', this.fileForm.fileType)
    //   this.fileFormShow = true
    // },
    // // 新增合同附件
    // addFile(row) {
    //   this.contractId = row.contractId
    //   this.isChange = true
    //   this.fileForm = {
    //     contractId: '',
    //     title: '',
    //     fileType: '',
    //     fileTypeName: '',
    //     url: '',
    //     amount: '',
    //     fileDesc: ''
    //   }
    //   this.fileFormShow = true
    // },
    // showPicker(type) {
    //   this.picker.loading = true
    //   this.picker.columns = []
    //   this.picker.formKey = type
    //   const optionItem = type + 'Options'
    //   this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
    //   this.picker.loading = false
    //   this.picker.visible = true
    // },
    // async pickerConfirm(value, key) {
    //   const optionItem = this.picker.formKey + 'Options'
    //   console.log('key:' + key)
    //   const name = this.picker.formKey + 'Name'
    //   this.fileForm[this.picker.formKey] = this.options[optionItem][key].dictValue
    //   this.fileForm[name] = this.options[optionItem][key].dictLabel
    //   this.picker.visible = false
    // },
    // pickerCancel() {
    //   this.picker.visible = false
    // },
    // deleteFile(row) {
    //   Dialog.confirm({
    //     message: '是否确认删除此条附件数据'
    //   })
    //     .then(() => {
    //       this.deleteFi(row.id)
    //     })
    //     .catch(() => {
    //     // on cancel
    //     })
    // },
    // async deleteFi(id) {
    //   const res = await newContract.deleteContractFile(id)
    //   if (res.code === 200) {
    //     await Toast.success('删除成功')
    //     setTimeout(() => {
    //       this.getContractFileList()
    //     }, 500)
    //   }
    // },
    // async fileBeforeClose(type, done) {
    //   if (type === 'confirm') {
    //     try {
    //       await this.$refs.fileForm.validate()
    //       if (this.isChange) {
    //         if (this.fileForm.id) {
    //           const res = await newContract.updateContractFile(this.fileForm)
    //           if (res.code === 200) {
    //             await Toast.success('修改成功')
    //             this.fileFormShow = false
    //             setTimeout(() => {
    //               this.getContractFileList()
    //             }, 500)
    //           }
    //         } else {
    //           this.fileForm.contractId = this.contractId
    //           const res = await newContract.addContractFile2(this.fileForm)
    //           if (res.code === 200) {
    //             await Toast.success('新增成功')
    //             this.fileFormShow = false
    //             setTimeout(() => {
    //               this.getContractFileList()
    //             }, 500)
    //           }
    //         }
    //       } else {
    //         this.fileForm.contractId = this.contractId
    //         await newContract.placeFile(this.fileForm)
    //         await this.reset()
    //           .then(() => {
    //             Toast.success('归档成功')
    //             this.fileFormShow = false
    //             setTimeout(() => {
    //               this.$router.go(-1)
    //             }, 500)
    //           }).catch(() => {})
    //         done()
    //       }
    //     } catch (err) {
    //       return done(false)
    //     }
    //     return done(false)
    //   } else {
    //     done()
    //     this.fileFormShow = false
    //   }
    // },
    // // 返回布尔值
    // beforeRead(file) {
    //   if (
    //     file.type !== 'application/pdf' || file.type !== 'application/msword' || file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    //   ) {
    //     Toast('请上传格式为 pdf/word 的文件')
    //     return false
    //   }
    //   return true
    // },
    // onOversize(file) {
    //   console.log(file)
    //   Toast('文件大小不能超过 10M')
    // },
    // async uploadContractPictureFiles(file) {
    //   const _file = file.file
    //   // 通过 FormData 对象上传文件
    //   var formData = new FormData()
    //   formData.append('file', _file)
    //   await newContract.uploadContractFile(formData)
    //     .then((res) => {
    //       if (res.code === 200) {
    //         this.fileForm.fileName = file.file.name
    //         this.fileForm.url = res.url
    //         Toast.success(res.msg)
    //       } else {
    //         Toast.fail('res.msg')
    //       }
    //     })
    //     .catch(function (error) {
    //       console.error(error)
    //     })
    // },
    // 保存附件
    // saveFile() {
    //   this.$refs.fileForm.validate(valid => {
    //     if (valid) {
    //       this.fileForm.contractId = this.contractId
    //       placeFile(this.fileForm).then(response => {
    //         this.msgSuccess('归档成功')
    //         this.fileVisible = false
    //         this.getList()
    //       })
    //     }
    //   })
    // },

    // 查看审批详情
    async viewStatus() {
      const res = await newContract.listVerify({ spNo: this.customer.spNo })
      if (res.code === 200) {
        this.viewStatusList = res.rows
        this.statusShow = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
.van-list{
  padding-top: 0;
}
.approval-status{
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .detail_span{
    font-size: 16px;
    flex: 1;
  }
  // span{
  //   font-size: 16px;
  // }
}
.gd_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.title{
  /deep/.van-tag{
    width: auto;
  }
}
.van-list{
  padding-bottom: 0;
}
.auditDetails /deep/.van-cell__value{
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
}
.auditDetails /deep/.van-dialog__content {
  height: 68%;
}
.nullifyClue /deep/.van-dialog__content {
  height: 68%;
}
.fileClue /deep/.van-dialog__content {
  height: 80%;
}
/deep/.van-step__circle{
  background-color: #969799;
}
/deep/.van-step__line{
  background-color: #ebedf0;
}
</style>
